module.exports = __webpack_public_path__ + "static/media/close.71f817e5.svg";